module.exports = __webpack_public_path__ + "img/word.856745be.svg";